'use strict';

/* eslint no-undef: "off" */
/**
 * main container
 */
define('cmsIndexMain',['homeNewsletter', 'xparkAnnouncementBar', 'xparkHeroBanner', 'xparkServiceHighlights', 'xparkPreLaunch', 'xparkVideoFeature', 'xparkFlashSale', 'xparkCouponCenter', 'xparkFindStore', 'xparkDiscoverMore', 'xparkCommunityPosts', 'xparkFaq', 'xparkTrendingNow', 'xparkBrandStory', 'xparkHomeFooter', 'xparkCategoryFloor', 'xparkProductFloor', 'xparkHomepageApi', 'busEvent', 'jquery'], function (homeNewsletter, xparkAnnouncementBar, xparkHeroBanner, xparkServiceHighlights, xparkPreLaunch, xparkVideoFeature, xparkFlashSale, xparkCouponCenter, xparkFindStore, xparkDiscoverMore, xparkCommunityPosts, xparkFaq, xparkTrendingNow, xparkBrandStory, xparkHomeFooter, xparkCategoryFloor, xparkProductFloor, xparkHomepageApi, busEvent, $) {
  var componentCodeMap = {
    announcement: 'xpark-announcement-bar',
    banner: 'xpark-hero-banner',
    banner_1: 'xpark-hero-banner',
    banner_2: 'xpark-hero-banner',
    homepre: 'xpark-pre-launch',
    service_promise: 'xpark-service-highlights',
    brand_story: 'xpark-brand-story',
    trending_now: 'xpark-trending-now',
    brand_video: 'xpark-video-feature',
    flashsales: 'xpark-flash-sale',
    coupon: 'xpark-coupon-center',
    categories: 'xpark-category-floor',
    product_showcase: 'xpark-product-floor',
    findastore: 'xpark-find-store',
    offline_stores: 'xpark-find-store',
    stores: 'xpark-find-store',
    discover_more: 'xpark-discover-more',
    homebbs: 'xpark-community-posts',
    faq: 'xpark-faq'
  };

  return {
    template: '\n      <div>\n        <div class="in-slider-container in-slider-header-container" id="index_body">\n          <div class="swiper-wrapper">\n            <div class="swiper-slide">\n              <div class="main-container xp-home-main" id="index_main">\n                <component\n                  v-for="item in sortedComponents"\n                  :key="item.code + item.name"\n                  :is="item.name"\n                  :sort-code="item.code"\n                ></component>\n                <home-newsletter></home-newsletter>\n                <xpark-home-footer></xpark-home-footer>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class="in-error">\n          <modal\n            name="newsletter"\n            :transition="\'overlay-fade\'"\n            width="75%"\n            height="auto"\n            @closed="closedModal"\n          >\n            <div class="in-modal">\n              <p v-text="modalMsg"></p>\n            </div>\n          </modal>\n        </div>\n      </div>\n    ',
    data: function data() {
      return {
        modalMsg: '',
        sortedComponents: [],
        bodyTop: 0,
        bodyHeight: 0
      };
    },
    created: function created() {
      var data = window.sessionStorage.getItem('sort');
      if (data) {
        this.sortedComponents = JSON.parse(data);
      }
    },

    components: {
      homeNewsletter: homeNewsletter,
      xparkAnnouncementBar: xparkAnnouncementBar,
      xparkHeroBanner: xparkHeroBanner,
      xparkServiceHighlights: xparkServiceHighlights,
      xparkPreLaunch: xparkPreLaunch,
      xparkVideoFeature: xparkVideoFeature,
      xparkFlashSale: xparkFlashSale,
      xparkCouponCenter: xparkCouponCenter,
      xparkFindStore: xparkFindStore,
      xparkDiscoverMore: xparkDiscoverMore,
      xparkCommunityPosts: xparkCommunityPosts,
      xparkFaq: xparkFaq,
      xparkTrendingNow: xparkTrendingNow,
      xparkBrandStory: xparkBrandStory,
      xparkHomeFooter: xparkHomeFooter,
      xparkCategoryFloor: xparkCategoryFloor,
      xparkProductFloor: xparkProductFloor
    },
    mounted: function mounted() {
      //
      this.fetchHomepageSort();
      this.showPopBoxUpEvent();
      this.listenScroll();
    },

    methods: {
      listenScroll: function listenScroll() {
        var that = this;
        // 监听滚动值
        $("#index_body").scroll(function (e) {
          that.bodyTop = $(this).scrollTop();
          that.bodyHeight = $("#index_main").height();
        });
        // 保存滚动位置
        this._saveScrollPosition = function () {
          var data = {};
          data.scroll = that.bodyTop;
          data.body = that.bodyHeight;

          $("#index_main section").each(function (item) {
            var _code = $(this).attr("sort-code");
            var _height = $(this).innerHeight();
            if (_code && _code !== '') {
              data[_code] = _height;
            }
          });
          window.sessionStorage.setItem('indexPosition', JSON.stringify(data));
        };
        $("#index_body").on("click", "a", function (e) {
          var link = $(this).attr('href');
          var target = $(this).attr("target");
          if (link && (link.indexOf('http') >= 0 || link.indexOf('/') === 0) && target !== '_blank') {
            that._saveScrollPosition();
          }
        });
        // window.addEventListener('beforeunload', this._saveScrollPosition);

        // 恢复滚动位置
        var savedPos = window.sessionStorage.getItem('indexPosition');
        if (savedPos) {
          this.$nextTick(function () {
            var data = JSON.parse(savedPos);
            setTimeout(function () {
              if (data && data.scroll) {
                $("#index_main section").each(function (item) {
                  var _code = $(this).attr("sort-code");
                  if (_code && data[_code]) {
                    $(this).css({ 'min-height': data[_code] + 'px' });
                  }
                });
                $("#index_main").css({ 'min-height': data.body + 'px' });
                $('#index_body').animate({ scrollTop: parseInt(data.scroll, 10) }, 300);
              }
            }, 1000);
            window.sessionStorage.removeItem('indexPosition');
          });
        }
        // ANOTHER:恢复滚动位置
        // this._resetScrollPosition = function() {
        //   const savedPos = window.sessionStorage.getItem('indexPosition');
        //   if (savedPos) {
        //     // $("#index_main").css({'min-height': savedPos + 'px'})
        //     $('#index_body').animate({ scrollTop: parseInt(savedPos, 10)}, 300);
        //     window.sessionStorage.setItem('indexPosition', '0');
        //   }
        // }
        // window.addEventListener('load', this._resetScrollPosition);
      },
      fetchHomepageSort: function fetchHomepageSort() {
        var _this = this;

        xparkHomepageApi.getHomepageSort().then(function (data) {
          if (!Array.isArray(data)) {
            _this.sortedComponents = [];
            return;
          }

          _this.sortedComponents = data.map(function (item) {
            return {
              code: item.code,
              name: componentCodeMap[item.code],
              position: Number(item.position || 0)
            };
          }).filter(function (item) {
            return item.name;
          }).sort(function (a, b) {
            return a.position - b.position;
          });
          _this.$nextTick(function () {
            window.sessionStorage.setItem('sort', JSON.stringify(_this.sortedComponents));
          });
        }).catch(function () {
          _this.sortedComponents = [];
        });
      },
      showPopBoxUpEvent: function showPopBoxUpEvent() {
        var _this2 = this;

        busEvent.$on('showPopBoxUpEvent', function (msg) {
          _this2.modalMsg = msg;
          _this2.showModal();
        });
      },
      showModal: function showModal() {
        var _this3 = this;

        this.$modal.show('newsletter');
        setTimeout(function () {
          _this3.hideModal();
        }, 3000);
      },
      hideModal: function hideModal() {
        this.$modal.hide('newsletter');
      },
      closedModal: function closedModal() {
        this.hideModal();
      }
    }
    // beforeDestroy() {
    //   // SPA 内组件销毁时也保存
    //   window.sessionStorage.setItem('indexPosition', this.bodyTop);
    //   window.removeEventListener('beforeunload', this._saveScrollPosition);
    // },
  };
});
